import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from '../api/api.service';
import { PromotionsGetAllResponse, PromotionsGetSingleResponse } from './promotions.models';

@Injectable({ providedIn: 'root' })
export class PromotionsResourceService {
    constructor(private api: ApiService) {}

    getAll(product: string | null): Observable<PromotionsGetAllResponse> {
        return this.api.get('promotion/getAll', product ? { product: product } : undefined);
    }

    getSingle(product: string | null, folderId: string | null): Observable<PromotionsGetSingleResponse> {
        return this.api.get('promotion/getSingle', { product: product, folderId: folderId });
    }
}
